import React from 'react';
import Entry from '../entry';
import { Flex, Text, Box } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image";

export default () => {
  const title = '8. Bypassing the Frido Sleigh CAPTEHA';
  const flag = '8Ia8LiZEwvyZr2WO';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Alabaster Snowball] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.youtube.com/watch?v=jmVPLwjm_zs'>Machine Learning Use Cases for Cyber Security</a></Flex>),
   (<Text>[Krampus Chat] Tell you what – if you can help me beat the Frido Sleigh contest (Objective 8), then I'll know I can trust you.
The contest is here on my screen and at fridosleigh.com.
No purchase necessary, enter as often as you want, so I am!
They set up the rules, and lately, I have come to realize that I have certain materialistic, cookie needs.
Unfortunately, it's restricted to elves only, and I can't bypass the CAPTEHA.
(That's Completely Automated Public Turing test to tell Elves and Humans Apart.)
I've already cataloged 12,000 images and decoded the API interface.
Can you help me bypass the CAPTEHA and submit lots of entries?</Text>)];
  const assignment = 'Help Krampus beat the Frido Sleigh contest. For hints on achieving this objective, please talk with Alabaster Snowball in the Speaker Unpreparedness Room.'
  const data = useStaticQuery(graphql`
    query {
      teachable: file(relativePath: { eq: "teachableMachine.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      fridoEmail: file(relativePath: { eq: "fridoEmail.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code8beat: file(relativePath: { eq: "code8beat.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code8ml5: file(relativePath: { eq: "code8ml5.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code8override: file(relativePath: { eq: "code8override.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code8server: file(relativePath: { eq: "code8server.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>We are in control of our browser. We will break the capture even if it gives us 5 seconds to solve.</Text>
      <Text my={2}>The first step is to train the image classification model. We will use <a rel="noopener noreferrer" href="https://teachablemachine.withgoogle.com/train">Google Teachable Machine</a> for that. Krampus conveniently provided us with 12,000 image set.</Text>
      <Img fluid={data.teachable.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The great thing is that we can download our trained model. To make it available to the browser we will spin up a Node.js/Express.js server on localhost.</Text>
      <Img fluid={data.code8server.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>We will use ML5.js library and its <code>image classifier</code> for our machine learning needs. We want <code>ml5</code> variable to live in the browser console, so will load the script.</Text>
      <Img fluid={data.code8ml5.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Here's a function that will use ML5 classifier based on our model to detect correct images, programmatically select them, and submit to fridosleigh.com for validation: </Text>
      <Img fluid={data.code8beat.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}><code>build_images</code> is overriden to call our capteha breating function. </Text>
      <Img fluid={data.code8override.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '30vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>On top of that we will override a couple of functions in the code to display fridosleigh server response instead of the "No Elf Alert"</Text>
      <Text my={2}>I was so inspired by this objective that I even recorded a PoC video:</Text>

        <iframe
        width="100%"
        height="500"
        minHeight="300px"
        title="frido"
        src="https://www.youtube.com/embed/PZAgudJM-NU"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading='lazy'>
        </iframe>

      <Text mt={2}> After we beat the CAPTEHA, we called <code>spam()</code> function that sent 100 contest entries.</Text>
      <Text mb={2}>Soon we get an email!</Text>
      <Img fluid={data.fridoEmail.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '45vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
